module.exports = __webpack_public_path__ + "static/media/hw_se_14.1338cda1.flv";